export const ButtonStyle = {
  baseStyle: {
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '4px',
    fontSize: [18, 14],
    width: [90, 120],
    height: '32px',
  },
  variants: {
    //solid
    wrapper: {
      primary: {
        backgroundColor: 'ORANGE',
        color: 'BLACK',
        _hover: {
          backgroundColor: 'ORANGE_HOVER',
        },
        _focus: {
          borderColor: 'ORANGE',
        },
      },
      careerSummaryWork: {
        margin: ['0 0 8px', '0'],
      },
      careerSummaryContinue: {
        margin: ['0', '0 16px 0 0'],
      },
      replayMockInterview: {
        padding: ".5rem",
        margin: "0",
        display: "block",
        width: "120px",
        fontWeight: "bold",
        textAlign: "center",
        borderRadius: "5px"
      },
      singleSectionMenu: {
        marginTop: '16px',
        float: 'left',
      },
      secondary: {
        backgroundColor: 'BLUE',
        color: 'WHITE',
        _hover: {
          color: 'BLUE',
          backgroundColor: 'WHITE',
        },
        _focus: {
          color: 'BLUE',
          borderColor: 'WHITE',
        },
      },
      newResume: {
        width: ['fit-content'],
        marginBottom: '1rem',
        backgroundColor: '#2642bb',
      },
      done: {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
        color: '#0000FF',
        fontWeight: 'normal',
        _hover: {
          textDecoration: 'none',
        },
      },
      tertiary: {
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: 'GRAY',
        color: 'GRAY_DARK',
        _hover: {
          backgroundColor: 'GRAY',
        },
        _focus: {
          borderColor: 'GRAY',
        },
      },
      backButton: {
        marginRight: [0, '24px'],
        marginTop: ['12px', 0],
      },
      previewClose: {
        margin: ['0', '0 16px 0 0'],
      },
      cancel: {
        margin: ['0', '0 16px 0 0'],
      },
      start: {
        borderColor: 'GRAY_2',
        color: 'GRAY_DARK',
      },
      quaternary: {
        backgroundColor: 'ORANGE',
        _hover: {
          backgroundColor: 'ORANGE_HOVER',
        },
        _focus: {
          borderColor: 'ORANGE',
        },
      },
      quinary: {
        backgroundColor: 'ORANGE',
        _hover: {
          backgroundColor: 'ORANGE_HOVER',
        },
        _focus: {
          borderColor: 'ORANGE',
        },
      },
      /*
      white: {
        backgroundColor: 'WHITE',
        border: '1px solid',
        borderColor: 'GRAY_DARK',
        color: 'GRAY_DARK',
        _hover: {
          backgroundColor: 'GRAY',
        },
      },


      exit: {
        backgroundColor: 'ORANGE',
        color: 'WHITE',
        float: 'left',
        _hover: {
          backgroundColor: 'ORANGE_HOVER',
        },
      },
      */
      empty: {
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
        border: 'none',
        width: 'auto',
        height: 'auto',
      },
      expertiseSearch: {
        margin: 0,
        padding: '0',
        height: '20px',
        width: '20px',
        minWidth: '20px',
        border: '1px solid #333',
        backgroundColor: 'white !important',
        paddingLeft: '2px',
        _hover: {
          backgroundColor: 'GRAY_2 !important',
          color: '#fff',
        },
      },
      /*
      start: {
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: 'GRAY',
        color: 'GRAY_DARK',
        _hover: {
          backgroundColor: 'GRAY',
        },
      },

       */
      update: {
        backgroundColor: 'GRAY_LIGHT',
        color: 'GRAY_DARK',
        _hover: {
          backgroundColor: 'GRAY_2',
          borderColor: 'GRAY_2',
          color: 'WHITE',
        },
      },
      /*
      review: {
        backgroundColor: 'ORANGE',
        color: 'GRAY_DARK',
        _hover: {
          backgroundColor: 'GRAY_2',
          borderColor: 'GRAY_2',
          color: 'WHITE',
        },
      },*/
      text: {
        backgroundColor: 'transparent',
        color: 'RED',
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        height: 'auto',
        width: 'auto',
        padding: '0',
        margin: '0',
        _hover: {
          textDecoration: 'underline',
        },
      },
      protip: {
        fontSize: '20px',
        color: 'NAVY',
        padding: '0px',
        // margin: ['0 0 8px', null, null, null],
        width: 'fit-content',
        height: ['20px', null, null, '28px'],
        //float: 'right',
        _hover: {
//        backgroundColor: 'NAVY',
          color: 'MAGENTA',
        },
        /*
        _focus: {
          borderColor: 'NAVY_HOVER',
        },

         */
      },
      bulletRowOpen: {
        width: 'fit-content',
        fontSize: [30, 24],
        marginTop: '12px',
      },

      bulletTag: {
        backgroundColor: 'transparent',
        border: '1px solid',
        width:'fit-content',
        padding: '0 .3rem',
        borderColor: 'GRAY',
        color: 'BLACK',
        margin: '12px 8px 0 0',
        _hover: {
          borderColor: 'ORANGE',
          backgroundColor: 'orange.200',
        },
        _focus: {
          borderColor: 'ORANGE',
          backgroundColor: 'orange.100',
        },
      },
      bulletTagActive: {
        backgroundColor: 'orange.100',
        width: 'fit-content',
        padding: '0 .3rem',
        border: '1px solid',
        borderColor: 'ORANGE',
        color: 'BLACK',
        margin: '12px 8px 0 0',
        _hover: {
          backgroundColor: 'orange.200',
        },
      },
      /*
      bulletTextButton: {
        backgroundColor: 'transparent',
        color: 'NAVY',
        fontSize: [14, 16, 16],
        fontWeight: 600,
        textTransform: 'none',
        width: 'auto',
        padding: '0',
        margin: '0',
        textDecoration: 'underline',
      },

       */

      icon: {
        width: 8,
        height: 8,
        border: 'none',
        margin: '0',
      },
      logout: {
        fontSize: '30px',
      },
      sumNav: {
        width: 8,
        height: 8,
        marginLeft: [0, null, 3],
        marginBottom: [2],
      },
      add: {
        width: 'auto',
      },
      // addAnother: {
      //   color: 'NAVY',
      //   backgroundColor: 'transparent',
      // },
      addDel: {
        padding: 0,
        p: 0,
        margin: 0,
        m: 0,
        backgroundColor: 'transparent',
        border: 'none',
        color: 'ORANGE',
        fontSize: 22,
        fontWeight: 400,
        width: 'auto',
        height: 'auto',
        alignSelf: 'baseline',
        paddingTop: '8px',
      },
      /*
      personalize: {
        height: 8,
        marginTop: [2, null, 0],
        marginLeft: 0,
        px: 1,
        color: 'GRAY_2',
        border: '1px solid',
        borderColor: 'GRAY',
        fontSize: ['15px', null, 16],
        textTransform: 'none',
        _hover: {
          backgroundColor: 'GRAY',
          color: 'WHITE',
        },
      },*/
      search: {
        width: 'auto',
        backgroundColor: 'transparent',
        color: 'GRAY_2',
      },
      download: {
        backgroundColor: 'ORANGE_LIGHT',
        textTransform: 'uppercase',
        fontSize: '14px',
        color: 'ORANGE_DARK',
        padding: 'auto',
        margin: '0 0 8px',
        height: ['30px', null, null, '42px'],
        border: '1px',
        borderRadius: '4px',
        borderColor: 'ORANGE_DARK',

        display: 'flex',
        justifyContent: 'flex-end',
        width: 'fit-content',
        marginRight: '.5rem',
        _hover: {
          backgroundColor: 'ORANGE_DARK',
          color: 'ORANGE_LIGHT',
        },
        _focus: {
          borderColor: 'ORANGE_TEXT',
        },
      },
      menuDownload: {
        marginRight: '0px !important',
      },
      skillSearch: {
        maxHeight: 'auto',
        width: 'auto',
        backgroundColor: 'orange.300',
        color: 'WHITE',
        // border: '1px',
        // borderColor: 'ORANGE_DARK',
        borderRadius: '4px',
        margin: ['0 12px 8px 0', '0 8px 8px 8px'],
      },
      // for development purposes only
      /*
      dev: {
        backgroundColor: 'GRAY',
        border: '3px solid',
        borderColor: 'purple',
        color: 'WHITE',
      },

       */
      //////////
    },
    defaultProps: {
      variants: 'solid',
    },
  },
};
